import { render } from "./aio-login-meta.vue?vue&type=template&id=6d564cae&scoped=true"
import script from "./aio-login-meta.vue?vue&type=script&lang=js"
export * from "./aio-login-meta.vue?vue&type=script&lang=js"

import "./aio-login-meta.vue?vue&type=style&index=0&id=6d564cae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d564cae"]])

export default __exports__